import Vue from 'vue'
import App from './App.vue'
import Vuelidate from 'vuelidate'
import Popover from 'vue-js-popover'
import VueResource from 'vue-resource'
import VueSweetalert2 from 'vue-sweetalert2';
import axios from 'axios';
import router from './router'
import VueAnalytics from 'vue-analytics';
// import 'bootstrap';
// import 'bootstrap/dist/css/bootstrap.min.css';

Vue.use(Vuelidate)
Vue.use(router)
Vue.use(Popover)
Vue.use(VueResource);
Vue.use(VueSweetalert2);
//   ID DE MEDICIÓN
Vue.use(VueAnalytics, {
  id: 'G-LY3W0QGF15',
  router
});

Vue.prototype.$axios = axios

Vue.prototype.$uriApi = 'https://api.cosmicprueba.cosmic.mx/'
axios.defaults.baseURL ='https://api.cosmicprueba.cosmic.mx/'

// Vue.prototype.$uriApi = 'https://localhost:44368/'
// axios.defaults.baseURL ='https://localhost:44368/'

import AOS from 'aos'
import 'aos/dist/aos.css'

new Vue({
  el: '#app',
  router,
  render: h => h(App),
  created () {
    AOS.init()
  }
})



// WEBPACK FOOTER //
// ./src/main.js